import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { HttpError } from '@rd/types';
import { Promocode, PromocodeUsage } from '@rd/types/promocode.type';
import { Observable } from 'rxjs';
import {
  ClearPromocodeData,
  ValidatePromocodeData,
} from '../store/actions/promocode.actions';
import {
  getPromocode,
  getPromocodeError,
  getPromocodeLoadingState,
  getPromocodeUsage,
} from '../store/selectors/promocode.selectors';
import { PromocodeValidateData } from '../types/promocode-validate-data.type';

@Injectable({ providedIn: 'root' })
export class PromocodeFacade {
  private store = inject(Store);

  promocode$: Observable<Promocode | null> = this.store.select(getPromocode);

  promocodeUsage$: Observable<PromocodeUsage | null> =
    this.store.select(getPromocodeUsage);

  promocodeLoading$: Observable<boolean> = this.store.select(
    getPromocodeLoadingState,
  );

  promocodeError$: Observable<HttpError | null> =
    this.store.select(getPromocodeError);

  validatePromocode(promocodeData: PromocodeValidateData): void {
    this.store.dispatch(ValidatePromocodeData({ promocodeData }));
  }

  clearPromocodeData(): void {
    this.store.dispatch(ClearPromocodeData());
  }
}
